// GENERATED by scripts/sync-shared.js from shared/passwordPolicy.json - do not edit; run `npm run shared:sync`.
export const PASSWORD_MIN_LENGTH = 12
export const PASSWORD_REQUIRE_UPPERCASE = true
export const PASSWORD_REQUIRE_LOWERCASE = true
export const PASSWORD_REQUIRE_NUMBER = true
export const PASSWORD_REQUIRE_SPECIAL_CHARACTER = true
export const PASSWORD_SPECIAL_CHARACTERS = '!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~'
export const PASSWORD_COMMON_PASSWORDS: string[] = [
	'password',
	'password123',
	'password1234',
	'welcome',
	'welcome123',
	'qwerty',
	'qwerty123',
	'letmein',
	'letmein123',
	'admin',
	'admin123',
	'changeme',
	'changeme123',
]
